import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const sendVerificationCode = id =>
  axios({
    method: 'post',
    url: `${publicAPI}/order/sendverificationcode/${id}`,
  });
